import {
  TRACKS_MAPPING,
  DELETE,
  SORT,
  MORE,
  LOADING,
  TOTAL,
  RESET,
  RESET_MODAL,
  SET_CANONICAL_POINTS,
  SET_FILTERES,
  SET_JERSEYS_OVERVIEW,
  SET_MODAL,
  SET_TABLE_MODE,
} from './mutation-types';
import { getDefaultState } from './state';

export default {
  [TRACKS_MAPPING](state, payload) {
    state.items = payload;
  },
  [DELETE](state, payload) {
    if (Array.isArray(payload.tracks_ids)) {
      state.items = state.items.filter(item => item.job_id !== payload.job_id || payload.tracks_ids.every(x => item.track_id !== x));
    } else {
      state.items = state.items.filter(item => item.job_id !== payload.job_id || item.track_id !== payload.track_id);
    }
  },
  [RESET](state) {
    Object.assign(state, getDefaultState());
  },
  [SET_FILTERES](state, payload) {
    state.filters = payload;
  },
  [SET_JERSEYS_OVERVIEW](state, payload) {
    state.jerseysOverview = payload;
  },
  [SORT](state, payload) {
    state.sort = payload;
  },
  [MORE](state, payload) {
    state.more = payload;
  },
  [LOADING](state, payload) {
    state.loading = payload;
  },
  [TOTAL](state, payload) {
    state.total = payload;
  },
  [RESET_MODAL](state) {
    state.modal.type = '';
    state.modal.details = {};
  },
  [SET_CANONICAL_POINTS](state, payload) {
    state.canonicalPoints = payload;
  },
  [SET_MODAL](state, payload) {
    state.modal.type = payload.type;
    state.modal.details = payload.details;
  },
  [SET_TABLE_MODE](state, payload) {
    state.tableMode = payload;
  },
};
